<template lang="pug">
button-base.button-modal-keep(@click='clickEvent')
  slot
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import ButtonBase from '@/components/atoms/ButtonBase.vue'

/**
 * モーダル内保存ボタン
 */
@Component({
  components: {
    ButtonBase,
  },
})
export default class ButtonModalKeep extends Vue {
  private clickEvent(key: Event): void {
    this.$emit('click', key)
  }
}
</script>

<style lang="stylus" scoped>
.button-modal-keep
  display flex
  align-items center
  justify-content center
  width 510px
  height 50px
  padding 15px
  text-decoration none
  color var(--color-input-manager-modal-keep__text)
  background-color var(--color-input-manager-modal-keep__background)
  letter-spacing 0.5px
  border-radius 15px
  overflow hidden

  &::before
    position absolute
    content ''
    width 100%
    height 100%
    border-radius 15px
    background-color var(--color-input-manager-modal-keep__background-hover)
    opacity 0

  &:hover
    &::before
      opacity 1
</style>
